(() => {
  const escapeHtml = (value) => String(value || '')
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');

  const quarantinedProductHandles = new Set([
    'accessori-casa-e-persona-702-14-2-02',
    'benessere-702-1',
    'piumini-e-cuscini-701-5-3'
  ]);

  const initQuarantinedProductGuard = () => {
    const productHandleMatch = window.location.pathname.match(/^\/products\/([^/?#]+)/);
    const productHandle = productHandleMatch ? productHandleMatch[1] : '';

    if (quarantinedProductHandles.has(productHandle)) {
      window.location.replace('/404');
      return;
    }

    document.querySelectorAll('[data-product-card]').forEach((card) => {
      const blockedLink = Array.from(card.querySelectorAll('a[href]')).some((link) => {
        try {
          const url = new URL(link.href, window.location.origin);
          const handle = url.pathname.match(/^\/products\/([^/?#]+)/)?.[1] || '';
          return quarantinedProductHandles.has(handle);
        } catch (_error) {
          return false;
        }
      });
      if (blockedLink) card.remove();
    });
  };

  const initQuantityInputs = () => {
    document.querySelectorAll('[data-quantity-input]').forEach((input) => {
      input.addEventListener('change', () => {
        const value = Number.parseInt(input.value, 10);
        if (Number.isNaN(value) || value < 1) {
          input.value = 1;
        }
      });
    });
  };

  const initProductCacheFallback = () => {
    const root = document.querySelector('[data-product-variant-root]');
    if (!root) return;

    const url = new URL(window.location.href);
    const hasViewParam = url.searchParams.has('view');
    const idInput = root.querySelector('[data-variant-id-input]');
    const variantId = idInput ? idInput.value : '';
    const latestProductBuild = '20260715-size-color-available-only-v4';

    const rootHtml = root.innerHTML || '';
    const staleInternalVariantLabel = /\bVariante\s+\d+\b/i.test(root.textContent || '');
    const staleProductShell = root.dataset.pdpCroBuild !== latestProductBuild || staleInternalVariantLabel;

    const refreshProductSection = () => {
      const wrapper = root.closest('.shopify-section');
      const sectionId = wrapper?.id?.replace(/^shopify-section-/, '');
      if (!wrapper || !sectionId || root.dataset.productSectionRefresh === latestProductBuild) return false;

      root.dataset.productSectionRefresh = latestProductBuild;
      const sectionUrl = new URL(window.location.href);
      sectionUrl.search = '';
      sectionUrl.searchParams.set('section_id', sectionId);
      if (variantId) sectionUrl.searchParams.set('variant', variantId);
      sectionUrl.searchParams.set('poligino_section_refresh', latestProductBuild);

      fetch(sectionUrl.toString(), { credentials: 'same-origin' })
        .then((response) => (response.ok ? response.text() : ''))
        .then((html) => {
          if (!html) return;
          const container = document.createElement('div');
          container.innerHTML = html;
          const freshRoot = container.querySelector('[data-product-variant-root]');
          if (!freshRoot || freshRoot.dataset.pdpCroBuild !== latestProductBuild) return;
          wrapper.innerHTML = container.innerHTML;
          initQuantityInputs();
          initProductVariants();
          initQuarantinedDescriptionCleanup();
          initDeliveryPromise();
        })
        .catch(() => {});
      return true;
    };

    if (hasViewParam && staleProductShell) {
      url.searchParams.delete('view');
      if (!url.searchParams.has('variant') && variantId) {
        url.searchParams.set('variant', variantId);
      }
      url.searchParams.set('poligino_refresh', latestProductBuild);
      window.location.replace(url.toString());
      return;
    }

    if (hasViewParam) return;

    if (staleProductShell && refreshProductSection()) return;

    if (staleProductShell && url.searchParams.get('poligino_refresh') !== latestProductBuild) {
      if (!url.searchParams.has('variant') && variantId) {
        url.searchParams.set('variant', variantId);
      }
      url.searchParams.set('poligino_refresh', latestProductBuild);
      window.location.replace(url.toString());
      return;
    }

    if (url.searchParams.has('variant') || root.querySelector('.product-education')) return;
    if (!variantId) return;

    url.searchParams.set('variant', variantId);
    window.location.replace(url.toString());
  };

  const initQuarantinedDescriptionCleanup = () => {
    const root = document.querySelector('[data-product-variant-root]');
    if (!root) return;

    const variantJson = root.querySelector('[data-variant-json]');
    let visibleVariants = [];
    try {
      visibleVariants = JSON.parse(variantJson?.textContent || '[]');
    } catch (_error) {
      visibleVariants = [];
    }

    const visibleValues = new Set();
    visibleVariants.forEach((variant) => {
      (variant.options || []).forEach((value) => {
        const normalized = String(value || '').trim();
        if (normalized) visibleValues.add(normalized);
      });
    });

    const metaVariants = window.ShopifyAnalytics?.meta?.product?.variants || [];
    if (!metaVariants.length && !root.dataset.quarantineDescriptionRetry) {
      root.dataset.quarantineDescriptionRetry = 'true';
      window.setTimeout(initQuarantinedDescriptionCleanup, 300);
      return;
    }

    const hiddenValues = new Set();
    metaVariants.forEach((variant) => {
      const title = String(variant.public_title || variant.title || '');
      title.split(' / ').forEach((part) => {
        const value = part.trim();
        if (value && !visibleValues.has(value)) hiddenValues.add(value);
      });
    });

    if (!hiddenValues.size) return;

    const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const cleanText = (input) => {
      let output = String(input || '');
      hiddenValues.forEach((value) => {
        const escaped = escapeRegExp(value);
        output = output
          .replace(new RegExp(`,\\s*${escaped}(?=\\s*[.,<])`, 'g'), '')
          .replace(new RegExp(`${escaped}\\s*,\\s*`, 'g'), '')
          .replace(new RegExp(`\\s*${escaped}\\s*\\.`, 'g'), '.');
      });
      return output;
    };

    document.querySelectorAll('.product-description-rich').forEach((description) => {
      description.innerHTML = cleanText(description.innerHTML);
    });

    document.querySelectorAll('script[type="application/ld+json"]').forEach((script) => {
      const cleaned = cleanText(script.textContent);
      if (cleaned !== script.textContent) script.textContent = cleaned;
    });
  };

  const initAllProductsLinkCleanup = () => {
    const freshCollectionView = 'linkview-v4';

    document.querySelectorAll('a[href]').forEach((link) => {
      let url;
      try {
        url = new URL(link.href, window.location.origin);
      } catch (error) {
        return;
      }
      if (url.origin !== window.location.origin || url.pathname !== '/collections/all') return;
      if (url.searchParams.get('page') === '1') {
        url.searchParams.delete('page');
      }
      if (
        !url.searchParams.has('view')
        || url.searchParams.get('view') === 'poligino-refresh-v4'
        || url.searchParams.get('view') === 'linkview-v2'
      ) {
        url.searchParams.set('view', freshCollectionView);
      }
      link.href = url.toString();
    });
  };

  const initCollectionsListCacheRepair = () => {
    const normalizedPath = window.location.pathname.replace(/\/+$/, '') || '/';
    if (normalizedPath !== '/collections') return;

    const grid = document.querySelector('.category-search-grid');
    const nav = document.querySelector('.site-header .nav');
    const hasStaleCollection = Boolean(grid && (
      grid.textContent.includes('Flat 08')
      || grid.textContent.includes('0 prodotti Bestseller')
      || grid.querySelector('a[href="/collections/accessori-outdoor"]')
    ));
    const hasStaleNav = Boolean(nav?.querySelector('a[href="/collections/soggiorno-arredo"], a[href="/collections/cucina-tavola"], a[href="/collections/persona-benessere"], a[href="/collections/accessori-outdoor"]'));
    if (!hasStaleCollection && !hasStaleNav) return;

    const assetLink = document.querySelector('link[href*="/assets/base.css"]');
    const assetBase = assetLink?.href?.includes('/assets/')
      ? `${assetLink.href.split('/assets/')[0]}/assets/`
      : `${window.location.origin}/cdn/shop/t/26/assets/`;
    const assetUrl = (file) => `${assetBase}${file}`;
    const escapeHtml = (value) => String(value).replace(/[&<>"']/g, (char) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;',
    })[char]);

    const oldCameraCard = grid?.querySelector('a[href="/collections/camera-da-letto"]');
    const cameraMatch = oldCameraCard?.textContent.match(/\b\d+\s+prodotti\b/i);
    const cameraLabel = cameraMatch ? cameraMatch[0] : 'Camera';
    const cards = [
      {
        href: '/collections/camera-da-letto',
        label: cameraLabel,
        title: 'Camera da letto',
        text: 'La selezione completa di prodotti attivi per letto, camera e zona ospiti.',
        image: 'poligino-cat-bedding-general.jpg',
        alt: 'Camera da letto',
      },
      {
        href: '/search?q=Federe',
        label: 'Federe',
        title: 'Federe e copricuscini',
        text: 'Cotone, raso, microfibra e seta con varianti per colore e misura.',
        image: 'poligino-cat-federe.jpg',
        alt: 'Federe e copricuscini',
      },
      {
        href: '/search?q=Copripiumino',
        label: 'Copripiumini',
        title: 'Set copripiumino',
        text: 'Set coordinati con varianti chiare per colore, misura e pezzi inclusi.',
        image: 'poligino-cat-copripiumini.jpg',
        alt: 'Copripiumini',
      },
      {
        href: '/search?q=Coperte',
        label: 'Coperte',
        title: 'Coperte e plaid',
        text: 'Plaid e coperte per letto e divano, utili per completare la camera.',
        image: 'poligino-cat-coperte-plaid.jpg',
        alt: 'Coperte e plaid',
      },
      {
        href: '/search?q=Coprimaterasso',
        label: 'Protezione',
        title: 'Coprimaterassi',
        text: 'Soluzioni pratiche per proteggere il materasso e mantenere il letto ordinato.',
        image: 'poligino-cat-coprimaterassi.jpg',
        alt: 'Coprimaterassi',
      },
      {
        href: '/search?q=Cuscino',
        label: 'Cuscini',
        title: 'Cuscini',
        text: 'Cuscini e accessori per completare il letto con misure e varianti chiare.',
        image: 'poligino-cat-bedding-general.jpg',
        alt: 'Cuscini',
      },
    ];

    if (grid && hasStaleCollection) {
      grid.dataset.poliginoCollectionsRepair = '20260605';
      grid.innerHTML = cards.map((card) => `
        <a class="category-card category-card--image" href="${escapeHtml(card.href)}">
          <div class="category-card__media">
            <img src="${escapeHtml(assetUrl(card.image))}" alt="${escapeHtml(card.alt)}" loading="lazy" width="1200" height="1200">
          </div>
          <div class="category-card__body">
            <span class="pill">${escapeHtml(card.label)}</span>
            <h3>${escapeHtml(card.title)}</h3>
            <p>${escapeHtml(card.text)}</p>
          </div>
        </a>
      `).join('');
    }

    const navItems = [
      ['Camera da letto', '/collections/camera-da-letto'],
      ['Federe', '/search?q=Federe'],
      ['Copripiumini', '/search?q=Copripiumino'],
      ['Coperte e plaid', '/search?q=Coperte'],
      ['Coprimaterassi', '/search?q=Coprimaterasso'],
    ];
    if (nav && hasStaleNav) {
      nav.dataset.taxonomyBuild = '20260605-bedroom-nav-v2';
      nav.innerHTML = navItems.map(([label, href]) => `<a class="nav__category" href="${escapeHtml(href)}">${escapeHtml(label)}</a>`).join('');
    }

    const mobilePanel = document.querySelector('.mobile-menu__panel');
    if (mobilePanel) {
      mobilePanel.querySelectorAll('a[href="/collections/soggiorno-arredo"], a[href="/collections/cucina-tavola"], a[href="/collections/persona-benessere"], a[href="/collections/accessori-outdoor"]').forEach((link) => link.remove());
      mobilePanel.querySelectorAll('.mobile-menu__group').forEach((group) => {
        const summary = group.querySelector('summary');
        if (summary && summary.textContent.trim() !== 'Camera da letto') group.remove();
      });
    }
  };

  const initProductVariants = () => {
    document.querySelectorAll('[data-product-variant-root]').forEach((root) => {
      if (root.dataset.productVariantsReady === 'true') return;
      root.dataset.productVariantsReady = 'true';
      root.dataset.richGalleryReady = 'theme-js';
      const variantData = root.querySelector('[data-variant-json]');
      const optionInputs = Array.from(root.querySelectorAll('[data-variant-option]'));
      const idInput = root.querySelector('[data-variant-id-input]');
      const priceContainer = root.querySelector('[data-product-price]');
      const status = root.querySelector('[data-variant-status]');
      const variantPicker = root.querySelector('[data-variant-picker]');
      const addButton = root.querySelector('[data-add-to-cart]');
      const quantityInput = root.querySelector('[data-quantity-input]');
      const purchaseVariant = root.querySelector('[data-purchase-variant]');
      const purchasePrice = root.querySelector('[data-purchase-price]');
      const purchaseQuantity = root.querySelector('[data-purchase-quantity]');
      const stickyBar = root.querySelector('[data-mobile-buy-bar]');
      const stickyButton = root.querySelector('[data-mobile-buy-submit]');
      const stickyTitle = root.querySelector('[data-mobile-buy-title]');
      const stickyPrice = root.querySelector('[data-mobile-buy-price]');
      const stickyQuantity = root.querySelector('[data-mobile-buy-quantity]');
      const galleryCurrent = root.querySelector('[data-gallery-current]');
      const productForm = root.querySelector('.product-form');
      const mainImage = root.querySelector('.product-gallery__main img');
      const thumbTrack = root.querySelector('[data-product-thumbs-track]');
      const galleryPrev = root.querySelector('[data-gallery-prev]');
      const galleryNext = root.querySelector('[data-gallery-next]');
      const aplusRoot = root.querySelector('[data-variant-aplus]');
      let thumbs = Array.from(root.querySelectorAll('[data-product-thumb]'));
      const optionGroups = Array.from(root.querySelectorAll('.variant-group[data-option-index]'));
      const optionLabels = Array.from(root.querySelectorAll('.variant-option'));
      const aplusCache = new Map();
      let aplusRequestController = null;
      let activeAplusVariantId = '';
      let pendingOptionIndex = -1;
      let pendingAnchorIndex = -1;
      let filterColorBySize = false;

      if (aplusRoot && root.dataset.initialVariantId) {
        aplusCache.set(root.dataset.initialVariantId, aplusRoot.hidden ? '' : aplusRoot.innerHTML);
      }

      if (!variantData || !idInput) return;

      let variants = [];
      try {
        variants = JSON.parse(variantData.textContent);
      } catch (_error) {
        return;
      }

      const hasAvailableVariants = variants.some((variant) => Boolean(variant.available));
      root.dataset.availableOptionsOnly = 'false';
      root.dataset.variantLinkage = 'bidirectional';
      root.dataset.variantSelectionMode = 'manual-linked';
      root.dataset.colorVisibility = 'all';
      if (status) {
        status.setAttribute('role', 'status');
        status.setAttribute('aria-live', 'polite');
        status.setAttribute('aria-atomic', 'true');
      }
      if (variantPicker) {
        variantPicker.hidden = false;
        variantPicker.removeAttribute('aria-hidden');
      }

      const selectedOptions = () => {
        const values = [];
        optionInputs.forEach((input) => {
          if (input.checked) {
            values[Number.parseInt(input.dataset.optionIndex, 10)] = input.value;
          }
        });
        return values;
      };

      const normalizeText = (value) => String(value || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim();

      const normalizeImageUrl = (value) => {
        const raw = String(value || '').trim();
        if (!raw) return '';
        try {
          const url = new URL(raw.startsWith('//') ? `https:${raw}` : raw, window.location.origin);
          const pathname = decodeURIComponent(url.pathname)
            .replace(/_(?:\d+x\d*|\d+x|x\d+)(?=\.)/g, '')
            .replace(/_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}(?=\.[^.]+$)/i, '');
          const shopifyFile = pathname.match(/\/(?:files|assets)\/([^/]+)$/i);
          return (shopifyFile ? shopifyFile[1] : `${url.hostname}${pathname}`).toLowerCase();
        } catch (_error) {
          return raw.split('?')[0].toLowerCase();
        }
      };

      const imageUrlAtWidth = (value, width) => {
        const raw = String(value || '').trim();
        if (!raw) return '';
        try {
          const url = new URL(raw.startsWith('//') ? `https:${raw}` : raw, window.location.origin);
          url.searchParams.set('width', String(width));
          return url.toString();
        } catch (_error) {
          return raw;
        }
      };
      const productProfile = root.dataset.productProfile || '';
      const productDisplayTitle = root.dataset.productDisplayTitle || '';
      const placeholderSizeIndex = root.dataset.hidePlaceholderSize === 'true'
        ? Number.parseInt(root.dataset.placeholderSizeIndex || '-1', 10)
        : -1;
      const colorDisplayMap = [
        [/\u85cf\u9752/, 'Blu Navy'],
        [/\u9152\u7ea2|\u9152\u7d05/, 'Bordeaux'],
        [/\u7c73\u8272/, 'Beige'],
        [/\u6d45\u7070/, 'Grigio Chiaro'],
        [/\u6df1\u7070/, 'Grigio Scuro'],
        [/\u6c34\u7eff|\u6c34\u7da0/, 'Verde Acqua'],
        [/\u69db\u5b50\u8910/, 'Nocciola'],
        [/\u6d45\u7d2b/, 'Lilla'],
        [/\u6df7\u88c5|\u6df7\u88dd/, 'Multicolore'],
        [/\u7c89\u8272|\u7c89/, 'Rosa'],
        [/\u7070\u8272|\u7070/, 'Grigio'],
        [/\u7eff\u8272|\u7da0\u8272|\u7eff|\u7da0/, 'Verde'],
        [/\u9ed1\u8272|\u9ed1/, 'Nero'],
        [/\u767d\u8272|\u767d/, 'Bianco']
      ];
      const displaySingleLabel = (value) => {
        const raw = String(value || '').trim();
        let text = raw
          .replace(/[\uff08(]\s*(?:\u780d|\u4e3b)\s*[\uff09)]/g, '')
          .replace(/\s+/g, ' ')
          .trim();
        for (const [pattern, label] of colorDisplayMap) {
          if (pattern.test(text)) return label;
        }
        if (productProfile === 'apparel') {
          const normalized = normalizeText(text);
          const modelMatch = text.match(/^anti\s*(\d+)[_\s-]+(\d{2})[\s-]+(\d{2})(?:\s+\S+)?$/i);
          if (modelMatch) return `EU ${modelMatch[2]}-${modelMatch[3]} / ${modelMatch[1]} paia`;
          if (normalized === 'standard') return 'Taglia da modello';
          if (normalized === 'variante') return 'Variante colore';
        }
        if (productProfile === 'food' && normalizeText(text) === 'standard') return 'Formato standard';
        return text;
      };
      const displayLabel = (value) => String(value || '')
        .split(/\s+\/\s+/)
        .map(displaySingleLabel)
        .filter(Boolean)
        .join(' / ');
      const isPlaceholderSizeLabel = (value) => ['standard', 'formato standard', 'misura standard', 'taglia standard'].includes(normalizeText(value));
      const isInternalApparelChoice = (value) => productProfile === 'apparel' && ['standard', 'variante'].includes(normalizeText(value));
      const visibleVariantOptions = (variant) => (
        Array.isArray(variant?.options)
          ? variant.options.filter((value, index) => !(index === placeholderSizeIndex && isPlaceholderSizeLabel(value)) && !isInternalApparelChoice(value))
          : []
      );
      const displayVariantTitle = (variant) => {
        const visibleOptions = visibleVariantOptions(variant).map(displaySingleLabel).filter(Boolean);
        if (visibleOptions.length) return visibleOptions.join(' / ');
        const fallback = displayLabel(variant?.displayTitle || variant?.title || '');
        return fallback && !isPlaceholderSizeLabel(fallback) ? fallback : productDisplayTitle;
      };
      const apparelSizeRank = (value) => {
        const text = String(value || '').toUpperCase().replace(/\s+/g, '');
        const fixed = new Map([
          ['XXS', 0],
          ['XS', 1],
          ['S', 2],
          ['M', 3],
          ['L', 4],
          ['XL', 5],
          ['1XL', 5],
          ['XXL', 6],
          ['2XL', 6],
          ['XXXL', 7],
          ['3XL', 7]
        ]);
        if (fixed.has(text)) return fixed.get(text);
        const numbered = text.match(/^(\d+)XL$/);
        return numbered ? 4 + Number(numbered[1]) : null;
      };
      const numericParts = (value) => (
        String(value || '').match(/\d+(?:[.,]\d+)?/g) || []
      ).map((part) => Number(part.replace(',', '.')));
      const optionSortKey = (value) => {
        const text = String(value || '').trim();
        const apparelRank = apparelSizeRank(text);
        if (apparelRank !== null) return { bucket: 10, numbers: [apparelRank], text };

        const apparelParts = text.split(/\s*(?:\/|[-–])\s*/).map((part) => apparelSizeRank(part));
        if (apparelParts.length > 1 && apparelParts.every((rank) => rank !== null)) {
          return { bucket: 10, numbers: apparelParts, text };
        }

        const euRange = text.match(/\bEU\s*(\d{1,3})(?:\s*[-–]\s*(\d{1,3}))?/i)
          || text.match(/\b(\d{1,3})(?:\s*[-–]\s*(\d{1,3}))?\s*EU\b/i);
        if (euRange) return { bucket: 20, numbers: [Number(euRange[1]), Number(euRange[2] || euRange[1])], text };

        const dimensions = text.match(/\b(\d+(?:[.,]\d+)?)\s*[x*×]\s*(\d+(?:[.,]\d+)?)(?:\s*[x*×/]\s*(\d+(?:[.,]\d+)?))?/i);
        if (dimensions) {
          const parts = dimensions.slice(1).filter(Boolean).map((part) => Number(part.replace(',', '.')));
          const area = parts.slice(0, 2).reduce((total, number) => total * number, 1);
          return { bucket: 30, numbers: [area, ...parts], text };
        }

        const numericRange = text.match(/\b(\d{1,3})\s*[-–]\s*(\d{1,3})\b/);
        if (numericRange) return { bucket: 40, numbers: [Number(numericRange[1]), Number(numericRange[2])], text };

        const pack = text.match(/\b(\d+)\s*(?:PZ|PCS|pezzi|pezzo|pz|pc|paia|pairs?)\b/i);
        if (pack) return { bucket: 50, numbers: [Number(pack[1])], text };

        const numbers = numericParts(text);
        if (numbers.length) return { bucket: 60, numbers, text };
        return { bucket: 90, numbers: [], text };
      };
      const compareOptionValues = (leftValue, rightValue) => {
        const left = optionSortKey(leftValue);
        const right = optionSortKey(rightValue);
        if (left.bucket !== right.bucket) return left.bucket - right.bucket;
        const length = Math.max(left.numbers.length, right.numbers.length);
        for (let index = 0; index < length; index += 1) {
          const difference = (left.numbers[index] ?? 0) - (right.numbers[index] ?? 0);
          if (difference) return difference;
        }
        return left.text.localeCompare(right.text, 'it', { numeric: true, sensitivity: 'base' });
      };
      const sortSemanticOptionDisplayValues = () => {
        optionGroups.forEach((group) => {
          const optionRole = normalizeText(group.dataset.optionRole);
          const optionName = normalizeText(group.dataset.optionName);
          const shouldSortGroup = optionRole === 'size'
            || optionRole === 'pack'
            || optionName.includes('taglia')
            || optionName.includes('misura')
            || optionName.includes('formato')
            || optionName.includes('size')
            || optionName.includes('dimension')
            || optionName.includes('numero')
            || optionName.includes('confezione')
            || optionName.includes('pack')
            || optionName.includes('pacco')
            || optionName.includes('paia')
            || optionName.includes('pezzi')
            || optionName.includes('pezzo');
          if (!shouldSortGroup) return;
          const valuesContainer = group.querySelector('.variant-values');
          if (!valuesContainer) return;
          const labels = Array.from(valuesContainer.querySelectorAll('.variant-option'));
          const sortedLabels = labels
            .map((label, index) => ({ label, index, value: label.querySelector('[data-variant-option]')?.value || '' }))
            .sort((left, right) => compareOptionValues(left.value, right.value) || left.index - right.index);
          sortedLabels.forEach(({ label }) => valuesContainer.appendChild(label));
          group.dataset.optionValuesSorted = 'semantic';
        });
      };

      const colorGroup = optionGroups.find((group) => group.dataset.optionRole === 'color') || optionGroups.find((group) => {
        const name = normalizeText(group.dataset.optionName);
        return name.includes('colore') || name.includes('color');
      });
      const colorOptionIndex = colorGroup ? Number.parseInt(colorGroup.dataset.optionIndex, 10) : -1;
      const sizeGroup = optionGroups.find((group) => group.dataset.optionRole === 'size') || optionGroups.find((group) => {
        const name = normalizeText(group.dataset.optionName);
        return name.includes('taglia') || name.includes('misura') || name.includes('formato') || name.includes('size') || name.includes('dimension');
      });
      const sizeOptionIndex = sizeGroup ? Number.parseInt(sizeGroup.dataset.optionIndex, 10) : -1;
      const optionRoleForIndex = (optionIndex) => (
        optionGroups.find((group) => Number.parseInt(group.dataset.optionIndex, 10) === optionIndex)?.dataset.optionRole || ''
      );
      const pendingPromptForIndex = (optionIndex, includeAvailable = false) => {
        const role = optionRoleForIndex(optionIndex);
        if (role === 'color') return includeAvailable ? 'Scegli un colore disponibile' : 'Scegli un colore';
        if (role === 'size') return includeAvailable ? 'Scegli una misura disponibile' : 'Scegli una misura';
        return includeAvailable ? 'Completa la selezione disponibile' : 'Completa la selezione';
      };
      const setPendingSelection = (targetOptionIndex, anchorOptionIndex) => {
        pendingOptionIndex = targetOptionIndex;
        pendingAnchorIndex = anchorOptionIndex;
        root.dataset.variantSelectionState = 'pending';
        root.dataset.pendingOptionRole = optionRoleForIndex(targetOptionIndex);
      };
      const clearPendingSelection = () => {
        pendingOptionIndex = -1;
        pendingAnchorIndex = -1;
        root.dataset.variantSelectionState = 'complete';
        delete root.dataset.pendingOptionRole;
      };
      let currentGallerySignature = '';
      let galleryScrollFrame = null;
      let galleryPruneFrame = null;

      const variantOptionCount = variants.reduce((count, variant) => (
        Math.max(count, Array.isArray(variant.options) ? variant.options.length : 0)
      ), 0);
      const optionCount = variantOptionCount || optionGroups.length;
      const optionValue = (value) => String(value ?? '');
      const fullOptionsKey = (options) => JSON.stringify(
        Array.from({ length: optionCount }, (_item, index) => optionValue(options[index]))
      );
      const partialOptionsKey = (pairs) => JSON.stringify(
        pairs.map(([index, value]) => [Number(index), optionValue(value)])
      );
      const buildVariantIndex = () => {
        const exactVariantByKey = new Map();
        const partialStateByKey = new Map();
        const availableByOptionValue = Array.from({ length: optionCount }, () => new Map());

        variants.forEach((variant) => {
          if (!Array.isArray(variant.options)) return;
          exactVariantByKey.set(fullOptionsKey(variant.options), variant);

          variant.options.forEach((value, index) => {
            if (!variant.available || !availableByOptionValue[index]) return;
            const key = optionValue(value);
            const list = availableByOptionValue[index].get(key) || [];
            list.push(variant);
            availableByOptionValue[index].set(key, list);
          });

          for (let mask = 1; mask < (1 << optionCount); mask += 1) {
            const pairs = [];
            for (let index = 0; index < optionCount; index += 1) {
              if (mask & (1 << index)) pairs.push([index, variant.options[index]]);
            }
            const key = partialOptionsKey(pairs);
            const previous = partialStateByKey.get(key);
            partialStateByKey.set(key, {
              exists: true,
              available: Boolean(previous?.available || variant.available)
            });
          }
        });

        return {
          exactVariantByKey,
          partialStateByKey,
          availableByOptionValue
        };
      };
      const variantIndex = buildVariantIndex();
      const variantFromOptions = (options) => variantIndex.exactVariantByKey.get(fullOptionsKey(options)) || null;
      const stateForOptions = (options) => {
        const pairs = [];
        for (let index = 0; index < optionCount; index += 1) {
          const value = options[index];
          if (value !== undefined && value !== null && value !== '') pairs.push([index, value]);
        }
        return variantIndex.partialStateByKey.get(partialOptionsKey(pairs)) || { exists: false, available: false };
      };
      const stateForLinkedOption = (options, optionIndex, value) => {
        const candidate = [...options];
        candidate[optionIndex] = value;
        return stateForOptions(candidate);
      };
      const stateForOptionValue = (optionIndex, value) => {
        const candidate = [];
        candidate[optionIndex] = value;
        return stateForOptions(candidate);
      };
      const setSelectedOptions = (options) => {
        optionInputs.forEach((input) => {
          const optionIndex = Number.parseInt(input.dataset.optionIndex, 10);
          input.checked = optionValue(input.value) === optionValue(options[optionIndex]);
        });
      };
      const clearSelectedOption = (optionIndex) => {
        optionInputs.forEach((input) => {
          if (Number.parseInt(input.dataset.optionIndex, 10) === optionIndex) input.checked = false;
        });
      };
      const findBestAvailableVariant = (optionIndex, value, preferredOptions) => {
        const candidates = variantIndex.availableByOptionValue[optionIndex]?.get(optionValue(value)) || [];
        let bestVariant = null;
        let bestScore = -1;

        candidates.forEach((variant) => {
          let score = 0;
          variant.options.forEach((variantValue, index) => {
            if (index !== optionIndex && optionValue(variantValue) === optionValue(preferredOptions[index])) {
              score += 1;
            }
          });
          if (score > bestScore) {
            bestScore = score;
            bestVariant = variant;
          }
        });

        return bestVariant;
      };
      const findBestInitialAvailableVariant = (preferredOptions) => {
        let bestVariant = null;
        let bestPrefixScore = -1;
        let bestTotalScore = -1;

        variants.forEach((variant) => {
          if (!variant.available) return;
          let prefixScore = 0;
          let totalScore = 0;
          let prefixOpen = true;

          variant.options.forEach((variantValue, index) => {
            const matches = optionValue(variantValue) === optionValue(preferredOptions[index]);
            if (matches) totalScore += 1;
            if (prefixOpen && matches) {
              prefixScore += 1;
            } else {
              prefixOpen = false;
            }
          });

          if (prefixScore > bestPrefixScore || (prefixScore === bestPrefixScore && totalScore > bestTotalScore)) {
            bestPrefixScore = prefixScore;
            bestTotalScore = totalScore;
            bestVariant = variant;
          }
        });

        return bestVariant;
      };

      const priceHtml = (variant) => {
        const price = `<span class="${variant.compareAtPrice ? 'price--sale' : ''}">${escapeHtml(variant.price)}</span>`;
        const compareAt = variant.compareAtPrice ? `<s>${escapeHtml(variant.compareAtPrice)}</s>` : '';
        return `<div class="price">${price}${compareAt}</div>`;
      };

      const renderAplus = (variant) => {
        if (!aplusRoot) return;
        if (!variant) {
          aplusRoot.hidden = true;
          aplusRoot.innerHTML = '';
          return;
        }
        const variantId = String(variant.id || '');
        activeAplusVariantId = variantId;
        const applyMarkup = (markup) => {
          if (activeAplusVariantId !== variantId) return;
          aplusRoot.innerHTML = markup;
          aplusRoot.hidden = !markup;
          aplusRoot.removeAttribute('aria-busy');
        };

        if (aplusCache.has(variantId)) {
          applyMarkup(aplusCache.get(variantId));
          return;
        }

        const sectionId = root.dataset.productSectionId;
        if (!sectionId || !variantId) {
          applyMarkup('');
          return;
        }

        if (aplusRequestController) aplusRequestController.abort();
        aplusRequestController = new AbortController();
        aplusRoot.setAttribute('aria-busy', 'true');
        const sectionUrl = new URL(window.location.pathname, window.location.origin);
        sectionUrl.searchParams.set('section_id', sectionId);
        sectionUrl.searchParams.set('variant', variantId);

        fetch(sectionUrl.toString(), {
          credentials: 'same-origin',
          signal: aplusRequestController.signal,
        })
          .then((response) => (response.ok ? response.text() : ''))
          .then((html) => {
            if (!html) return;
            const container = document.createElement('div');
            container.innerHTML = html;
            const freshAplus = container.querySelector('[data-variant-aplus]');
            const markup = freshAplus && !freshAplus.hidden ? freshAplus.innerHTML : '';
            aplusCache.set(variantId, markup);
            applyMarkup(markup);
          })
          .catch((error) => {
            if (error.name !== 'AbortError' && activeAplusVariantId === variantId) {
              aplusRoot.removeAttribute('aria-busy');
            }
          });
      };

      const bindThumbClick = (thumb) => {
        thumb.addEventListener('click', () => {
          if (!mainImage || !thumb.dataset.imageSrc) return;
          mainImage.src = thumb.dataset.imageSrc;
          mainImage.srcset = '';
          mainImage.alt = thumb.dataset.imageAlt || '';
          thumbs.forEach((item) => {
            const isActive = item === thumb;
            item.classList.toggle('is-active', isActive);
            item.setAttribute('aria-current', isActive ? 'true' : 'false');
          });
        });
      };

      const removeDynamicVariantGallery = () => {
        root
          .querySelectorAll('[data-dynamic-variant-gallery="true"]')
          .forEach((thumb) => thumb.remove());
        thumbs = Array.from(root.querySelectorAll('[data-product-thumb]'));
      };

      const renderVariantGallery = (variant) => {
        if (!thumbTrack) return;
        removeDynamicVariantGallery();
        const gallery = Array.isArray(variant?.gallery) ? variant.gallery : [];
        const seenGalleryImages = new Set();
        const selectedVariantImageKey = normalizeImageUrl(variant?.image);
        if (selectedVariantImageKey) seenGalleryImages.add(selectedVariantImageKey);
        thumbs.forEach((thumb) => {
          const imageKey = normalizeImageUrl(thumb.dataset.imageSrc);
          if (imageKey) seenGalleryImages.add(imageKey);
        });
        gallery.forEach((image, index) => {
          const src = image.src || image.url || image.cdnUrl || '';
          const imageSrc = image.largeSrc || src;
          const imageKey = normalizeImageUrl(imageSrc);
          if (!src || !imageKey || seenGalleryImages.has(imageKey)) return;
          seenGalleryImages.add(imageKey);
          const alt = displayLabel(image.alt) || displayVariantTitle(variant) || '';
          const button = document.createElement('button');
          button.className = 'product-thumb';
          button.type = 'button';
          button.dataset.productThumb = '';
          button.dataset.dynamicVariantGallery = 'true';
          button.dataset.galleryKind = 'variant-gallery';
          button.dataset.galleryColor = colorOptionIndex >= 0 ? variant.options[colorOptionIndex] : (image.color || '');
          button.dataset.gallerySize = sizeOptionIndex >= 0 ? variant.options[sizeOptionIndex] : (image.size || '');
          button.dataset.imageSrc = imageSrc;
          button.dataset.imageAlt = alt;
          button.setAttribute('aria-label', alt || `Immagine variante ${index + 1}`);
          button.setAttribute('aria-current', 'false');

          const img = document.createElement('img');
          img.src = image.thumbnailSrc || src;
          img.alt = alt;
          img.loading = 'lazy';
          button.append(img);
          bindThumbClick(button);
          thumbTrack.append(button);
          thumbs.push(button);
        });
      };

      const updateImage = (variant) => {
        if (!mainImage || !variant || !variant.image) return;
        const contractMainThumb = root.querySelector('[data-gallery-contract-main]');
        if (contractMainThumb) {
          contractMainThumb.dataset.mediaId = variant.mediaId || '';
          contractMainThumb.dataset.imageSrc = variant.image;
          contractMainThumb.dataset.imageAlt = variant.imageAlt || '';
          contractMainThumb.setAttribute('aria-label', variant.imageAlt || 'Immagine principale');
          const contractMainImage = contractMainThumb.querySelector('img');
          if (contractMainImage) {
            contractMainImage.src = imageUrlAtWidth(variant.image, 240);
            contractMainImage.srcset = '';
            contractMainImage.alt = variant.imageAlt || '';
          }
        }
        mainImage.src = variant.image;
        mainImage.srcset = '';
        mainImage.alt = variant.imageAlt || '';

        let activeThumb = null;
        thumbs.forEach((thumb) => {
          const isActive = thumb.dataset.mediaId && Number(thumb.dataset.mediaId) === Number(variant.mediaId);
          thumb.classList.toggle('is-active', isActive);
          thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
          if (isActive) activeThumb = thumb;
        });

        if (activeThumb && !activeThumb.hidden && thumbTrack) {
          activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        }
      };

      const visibleThumbs = () => thumbs.filter((thumb) => !thumb.hidden && !thumb.classList.contains('is-hidden'));

      const setThumbHidden = (thumb, isHidden) => {
        thumb.hidden = isHidden;
        thumb.classList.toggle('is-hidden', isHidden);
      };

      const pruneDuplicateThumbs = () => {
        const seenThumbImages = new Set();
        const nextThumbs = [];
        Array.from(root.querySelectorAll('[data-product-thumb]')).forEach((thumb) => {
          const image = thumb.querySelector('img');
          const imageKey = normalizeImageUrl(thumb.dataset.imageSrc || image?.currentSrc || image?.src || '');
          if (imageKey && seenThumbImages.has(imageKey) && thumb.dataset.dynamicVariantGallery === 'true') {
            thumb.remove();
            return;
          }
          if (imageKey) seenThumbImages.add(imageKey);
          nextThumbs.push(thumb);
        });
        thumbs = nextThumbs;
        updateGalleryArrows();
      };

      const scheduleDuplicateThumbPrune = () => {
        window.setTimeout(pruneDuplicateThumbs, 0);
        window.setTimeout(pruneDuplicateThumbs, 80);
        window.setTimeout(pruneDuplicateThumbs, 300);
      };

      const updateGalleryArrows = () => {
        if (!thumbTrack || !galleryPrev || !galleryNext) return;
        const hasOverflow = visibleThumbs().length > 1 && thumbTrack.scrollWidth > thumbTrack.clientWidth + 2;
        galleryPrev.hidden = !hasOverflow;
        galleryNext.hidden = !hasOverflow;
        if (!hasOverflow) return;

        const atStart = thumbTrack.scrollLeft <= 2;
        const atEnd = thumbTrack.scrollLeft + thumbTrack.clientWidth >= thumbTrack.scrollWidth - 2;
        galleryPrev.disabled = atStart;
        galleryNext.disabled = atEnd;
      };

      const updateVisibleThumbs = (options, variant) => {
        const selectedColor = colorOptionIndex >= 0 ? normalizeText(options[colorOptionIndex]) : '';
        const selectedSize = sizeOptionIndex >= 0 ? normalizeText(options[sizeOptionIndex]) : '';
        const signature = `${selectedColor}\u0000${selectedSize}`;
        const selectionChanged = signature !== currentGallerySignature;
        currentGallerySignature = signature;

        const eligibleThumbs = [];
        thumbs.forEach((thumb) => {
          const kind = thumb.dataset.galleryKind || '';
          const thumbColor = normalizeText(thumb.dataset.galleryColor);
          const thumbSize = normalizeText(thumb.dataset.gallerySize);
          const mediaId = thumb.dataset.mediaId ? Number(thumb.dataset.mediaId) : null;
          const isCurrentVariantImage = variant?.mediaId && mediaId === Number(variant.mediaId);
          const isSelectedColorImage = selectedColor && thumbColor && thumbColor === selectedColor;
          const colorMatchesVariant = !selectedColor || !thumbColor || thumbColor === selectedColor;
          const sizeMatchesVariant = !selectedSize || !thumbSize || thumbSize === selectedSize;
          const isSelectedVariantGallery = colorMatchesVariant && sizeMatchesVariant;
          let shouldShow = true;

          if (kind === 'gallery-contract-main') {
            shouldShow = true;
          } else if (kind === 'gallery-contract-detail' || kind === 'gallery-fallback-detail') {
            shouldShow = true;
          } else if (kind === 'variant-main') {
            shouldShow = Boolean(isCurrentVariantImage);
          } else if (kind === 'variant-gallery') {
            shouldShow = Boolean(isSelectedVariantGallery);
          } else if (kind === 'color-gallery') {
            shouldShow = Boolean(isSelectedColorImage);
          } else if (kind === 'general') {
            shouldShow = true;
          } else if (selectedColor) {
            shouldShow = Boolean(isSelectedColorImage || isCurrentVariantImage);
          }

          setThumbHidden(thumb, !shouldShow);
          if (shouldShow) eligibleThumbs.push(thumb);
        });

        const activeVariantThumb = eligibleThumbs.find((thumb) => (
          variant?.mediaId
          && thumb.dataset.mediaId
          && Number(thumb.dataset.mediaId) === Number(variant.mediaId)
        ));
        const contractMainThumb = eligibleThumbs.find((thumb) => thumb.dataset.galleryKind === 'gallery-contract-main');
        const primaryThumb = activeVariantThumb || contractMainThumb || null;
        const selectedVariantGalleryThumbs = eligibleThumbs.filter((thumb) => thumb.dataset.galleryKind === 'variant-gallery');
        const fallbackDetailThumbs = eligibleThumbs.filter((thumb) => (
          thumb.dataset.galleryKind === 'gallery-fallback-detail'
          || thumb.dataset.galleryKind === 'gallery-contract-detail'
        ));
        const prioritizedThumbs = [
          ...(primaryThumb ? [primaryThumb] : []),
          ...selectedVariantGalleryThumbs,
          ...fallbackDetailThumbs,
        ];
        const prioritizedSet = new Set(prioritizedThumbs);
        const orderedThumbs = [
          ...prioritizedThumbs,
          ...eligibleThumbs.filter((thumb) => !prioritizedSet.has(thumb)),
        ];
        const visibleImageKeys = new Set();
        let visibleImageCount = 0;
        orderedThumbs.forEach((thumb) => {
          const image = thumb.querySelector('img');
          const imageKey = normalizeImageUrl(thumb.dataset.imageSrc || image?.currentSrc || image?.src || '');
          const duplicate = Boolean(imageKey && visibleImageKeys.has(imageKey));
          const overLimit = visibleImageCount >= 8;
          if (duplicate || overLimit) {
            setThumbHidden(thumb, true);
            return;
          }
          if (imageKey) visibleImageKeys.add(imageKey);
          visibleImageCount += 1;
          setThumbHidden(thumb, false);
        });

        if (selectionChanged && thumbTrack) thumbTrack.scrollTo({ left: 0, behavior: 'auto' });
        updateGalleryArrows();
      };

      const updateOptionLabels = (options) => {
        optionGroups.forEach((group) => {
          const label = group.querySelector('[data-option-value-label]');
          if (label) {
            const optionIndex = Number.parseInt(group.dataset.optionIndex, 10);
            const selectedValue = options[optionIndex];
            label.textContent = selectedValue
              ? displayLabel(selectedValue)
              : pendingPromptForIndex(optionIndex);
          }
        });
      };

      const updatePurchaseQuantity = () => {
        const quantity = quantityInput ? quantityInput.value || '1' : '1';
        if (purchaseQuantity) purchaseQuantity.textContent = quantity;
        if (stickyQuantity) stickyQuantity.textContent = `Qtà ${quantity}`;
      };

      const updateAvailability = (options) => {
        const availableCountByGroup = new Map();

        optionInputs.forEach((input) => {
          const optionIndex = Number.parseInt(input.dataset.optionIndex, 10);
          const state = stateForLinkedOption(options, optionIndex, input.value);
          const globalState = stateForOptionValue(optionIndex, input.value);
          const isAvailable = Boolean(state.available);
          const isGloballySelectable = Boolean(globalState.available);
          const isPendingTarget = optionIndex === pendingOptionIndex;
          const group = input.closest('.variant-group');
          const optionRole = group?.dataset.optionRole || '';
          const hideUnavailableColor = filterColorBySize && optionIndex === colorOptionIndex && !isAvailable;
          const isSelectable = hideUnavailableColor
            ? false
            : (isPendingTarget ? isAvailable : isGloballySelectable);
          const isLinkedUnavailable = !isAvailable && isGloballySelectable;
          const label = input.closest('.variant-option');
          const stateLabel = label?.querySelector('.variant-option__state');

          input.disabled = !isSelectable;
          if (isSelectable) {
            input.removeAttribute('disabled');
          } else {
            input.setAttribute('disabled', 'disabled');
          }
          input.dataset.optionState = isAvailable
            ? 'available'
            : (isLinkedUnavailable ? 'linked-unavailable' : (globalState.exists ? 'sold-out' : 'unavailable'));
          if (label) {
            label.hidden = hideUnavailableColor;
            label.classList.toggle('is-linked-unavailable', isLinkedUnavailable);
            label.classList.toggle('is-disabled', !isSelectable);
            label.classList.toggle('unavailable', !isSelectable && !globalState.exists);
            label.classList.toggle('is-unavailable', !isSelectable);
            label.classList.toggle('sold-out', !isSelectable && globalState.exists);
            label.dataset.optionState = input.dataset.optionState;
            label.setAttribute('aria-disabled', isSelectable ? 'false' : 'true');
            if (hideUnavailableColor) {
              label.setAttribute('aria-hidden', 'true');
            } else {
              label.removeAttribute('aria-hidden');
            }
          }
          if (stateLabel) {
            if (isLinkedUnavailable) {
              stateLabel.textContent = isPendingTarget
                ? (optionRole === 'color'
                  ? 'Non disponibile per questa misura'
                  : (optionRole === 'size' ? 'Non disponibile per questo colore' : 'Non disponibile per questa selezione'))
                : (optionRole === 'size'
                  ? 'Scegli per vedere i colori'
                  : (optionRole === 'color' ? 'Disponibile in altre misure' : 'Disponibile in un\'altra combinazione'));
            } else if (!isSelectable) {
              stateLabel.textContent = globalState.exists ? 'Esaurito' : 'Non disponibile';
            } else {
              stateLabel.textContent = '';
            }
            stateLabel.hidden = isAvailable || hideUnavailableColor;
            stateLabel.setAttribute('aria-hidden', (isAvailable || hideUnavailableColor) ? 'true' : 'false');
          }

          if (isAvailable) {
            availableCountByGroup.set(optionIndex, (availableCountByGroup.get(optionIndex) || 0) + 1);
          }
        });

        optionGroups.forEach((group) => {
          const optionIndex = Number.parseInt(group.dataset.optionIndex, 10);
          group.dataset.availableOptionCount = String(availableCountByGroup.get(optionIndex) || 0);
        });
      };

      const announceVariantChange = (variant, options, meta = {}) => {
        root.dispatchEvent(new CustomEvent('variant:change', {
          bubbles: true,
          detail: {
            variant,
            selectedOptions: [...options],
            autoSelected: Boolean(meta.autoSelected),
            requestedOptions: meta.requestedOptions ? [...meta.requestedOptions] : null,
            unavailable: Boolean(meta.unavailable),
            pending: Boolean(meta.pendingOptionIndex >= 0),
            pendingOptionRole: meta.pendingOptionIndex >= 0 ? optionRoleForIndex(meta.pendingOptionIndex) : ''
          }
        }));
      };

      const renderVariant = (variant, options, meta = {}) => {
        if (variant) {
          clearPendingSelection();
        } else if (Number.isInteger(meta.pendingOptionIndex) && meta.pendingOptionIndex >= 0) {
          setPendingSelection(meta.pendingOptionIndex, meta.pendingAnchorIndex ?? -1);
        }
        updateOptionLabels(options);
        updateAvailability(options);

        if (!variant) {
          const isPending = pendingOptionIndex >= 0;
          const unavailableLabel = isPending
            ? pendingPromptForIndex(pendingOptionIndex, true)
            : (hasAvailableVariants ? 'Combinazione non disponibile' : 'Esaurito');
          const buttonLabel = isPending ? pendingPromptForIndex(pendingOptionIndex) : unavailableLabel;
          idInput.value = '';
          if (addButton) {
            addButton.disabled = true;
            addButton.textContent = buttonLabel;
          }
          if (stickyButton) {
            stickyButton.disabled = true;
            stickyButton.textContent = buttonLabel;
          }
          if (status) {
            status.innerHTML = unavailableLabel;
          }
          if (purchaseVariant) purchaseVariant.textContent = buttonLabel;
          if (purchasePrice) purchasePrice.textContent = '-';
          removeDynamicVariantGallery();
          updateVisibleThumbs(options, null);
          renderAplus(null);
          announceVariantChange(null, options, { ...meta, unavailable: true });
          return;
        }

        idInput.value = variant.id;
        const variantDisplayTitle = displayVariantTitle(variant);
        if (priceContainer) priceContainer.innerHTML = priceHtml(variant);
        if (purchaseVariant) purchaseVariant.textContent = variantDisplayTitle;
        if (purchasePrice) purchasePrice.textContent = variant.price;
        if (stickyTitle) stickyTitle.textContent = variantDisplayTitle;
        if (stickyPrice) stickyPrice.textContent = variant.price;
        if (galleryCurrent) galleryCurrent.textContent = variantDisplayTitle;
        updatePurchaseQuantity();
        if (status) {
          const autoSelectionAnnouncement = meta.autoSelected
            ? '<span class="visually-hidden">. Le opzioni sono state aggiornate alla combinazione disponibile.</span>'
            : '';
          status.innerHTML = variant.available
            ? `<span class="variant-status__dot"></span>Disponibile${autoSelectionAnnouncement}`
            : 'Esaurito';
        }
        if (addButton) {
          addButton.disabled = !variant.available;
          addButton.textContent = variant.available ? 'Aggiungi al carrello' : 'Esaurito';
        }
        if (stickyButton) {
          stickyButton.disabled = !variant.available;
          stickyButton.textContent = variant.available ? 'Aggiungi al carrello' : 'Esaurito';
        }

        renderVariantGallery(variant);
        updateImage(variant);
        updateVisibleThumbs(options, variant);
        renderAplus(variant);
        scheduleDuplicateThumbPrune();

        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
        announceVariantChange(variant, options, meta);
      };

      const updateVariant = (changedInput = null) => {
        const options = selectedOptions();
        const variant = variantFromOptions(options);
        const changedOptionIndex = changedInput
          ? Number.parseInt(changedInput.dataset.optionIndex, 10)
          : -1;

        if (changedOptionIndex === sizeOptionIndex) {
          filterColorBySize = true;
          root.dataset.colorVisibility = 'available-for-size';
        }

        if (variant?.available) {
          renderVariant(variant, options);
          return;
        }

        if (hasAvailableVariants) {
          const optionIndex = changedOptionIndex;
          const linkedTargetIndex = optionIndex === sizeOptionIndex
            ? colorOptionIndex
            : (optionIndex === colorOptionIndex ? sizeOptionIndex : -1);

          if (changedInput && linkedTargetIndex >= 0 && stateForOptionValue(optionIndex, changedInput.value).available) {
            clearSelectedOption(linkedTargetIndex);
            const partialOptions = selectedOptions();
            if (stateForOptions(partialOptions).available) {
              setPendingSelection(linkedTargetIndex, optionIndex);
              renderVariant(null, partialOptions, {
                pendingOptionIndex: linkedTargetIndex,
                pendingAnchorIndex: optionIndex,
                requestedOptions: options
              });
              return;
            }
          }

          if (pendingOptionIndex >= 0 && stateForOptions(options).available) {
            renderVariant(null, options, {
              pendingOptionIndex,
              pendingAnchorIndex,
              requestedOptions: options
            });
            return;
          }

          const fallbackVariant = changedInput
            ? findBestAvailableVariant(optionIndex, changedInput.value, options)
            : findBestInitialAvailableVariant(options);
          if (fallbackVariant) {
            setSelectedOptions(fallbackVariant.options);
            renderVariant(fallbackVariant, fallbackVariant.options, {
              autoSelected: true,
              requestedOptions: options
            });
            return;
          }
        }

        renderVariant(variant, options, {
          unavailable: Boolean(!variant || !variant.available)
        });
      };

      const bindStickySubmit = () => {
        if (!stickyButton || !productForm) return;
        stickyButton.addEventListener('click', () => {
          if (stickyButton.disabled) return;
          if (typeof productForm.requestSubmit === 'function') {
            productForm.requestSubmit();
          } else {
            productForm.submit();
          }
        });
      };

      const bindStickyVisibility = () => {
        if (!stickyBar || !addButton) return;
        const mobileQuery = window.matchMedia('(max-width: 640px)');
        let visibilityFrame = null;
        const syncVisibility = () => {
          visibilityFrame = null;
          const rect = addButton.getBoundingClientRect();
          const buttonOutsideViewport = rect.bottom < 0 || rect.top > window.innerHeight;
          stickyBar.classList.toggle('is-visible', mobileQuery.matches && buttonOutsideViewport);
        };
        const scheduleVisibilitySync = () => {
          if (visibilityFrame) return;
          visibilityFrame = window.requestAnimationFrame(syncVisibility);
        };
        window.addEventListener('scroll', scheduleVisibilitySync, { passive: true });
        window.addEventListener('resize', scheduleVisibilitySync);
        if (typeof mobileQuery.addEventListener === 'function') {
          mobileQuery.addEventListener('change', scheduleVisibilitySync);
        }
        syncVisibility();
      };

      const scrollThumbTrack = (direction) => {
        if (!thumbTrack) return;
        const amount = Math.max(thumbTrack.clientWidth * 0.82, 160);
        thumbTrack.scrollBy({ left: amount * direction, behavior: 'smooth' });
        window.setTimeout(updateGalleryArrows, 280);
      };

      const bindGalleryArrows = () => {
        if (!thumbTrack || !galleryPrev || !galleryNext) return;
        galleryPrev.addEventListener('click', () => scrollThumbTrack(-1));
        galleryNext.addEventListener('click', () => scrollThumbTrack(1));
        thumbTrack.addEventListener('scroll', () => {
          if (galleryScrollFrame) return;
          galleryScrollFrame = window.requestAnimationFrame(() => {
            galleryScrollFrame = null;
            updateGalleryArrows();
          });
        }, { passive: true });
        window.addEventListener('resize', updateGalleryArrows);
        if ('MutationObserver' in window) {
          const observer = new MutationObserver(() => {
            if (galleryPruneFrame) return;
            galleryPruneFrame = window.requestAnimationFrame(() => {
              galleryPruneFrame = null;
              pruneDuplicateThumbs();
            });
          });
          observer.observe(thumbTrack, { childList: true });
        }
      };

      bindStickySubmit();
      bindStickyVisibility();
      bindGalleryArrows();

      if (quantityInput) {
        quantityInput.addEventListener('input', updatePurchaseQuantity);
        quantityInput.addEventListener('change', updatePurchaseQuantity);
      }

      updatePurchaseQuantity();

      thumbs.forEach(bindThumbClick);

      if (optionInputs.length === 0) return;

      sortSemanticOptionDisplayValues();

      optionLabels.forEach((label) => {
        label.addEventListener('click', () => {
          const input = label.querySelector('[data-variant-option]');
          if (!input || input.disabled || input.checked) return;
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });

      optionInputs.forEach((input) => {
        input.disabled = false;
        input.removeAttribute('disabled');
        input.addEventListener('change', () => updateVariant(input));
      });

      updateVariant();
      scheduleDuplicateThumbPrune();
    });
  };

  const initProductCardSwatches = () => {
    document.querySelectorAll('[data-product-card]').forEach((card) => {
      if (card.dataset.cardSwatchesReady === 'true') return;
      card.dataset.cardSwatchesReady = 'true';
      const primaryImage = card.querySelector('.product-card__image--primary');
      const cardLinks = Array.from(card.querySelectorAll('.product-card__media, .product-card__title a, .product-card__quick .button'));
      const swatches = Array.from(card.querySelectorAll('[data-card-swatch]'));

      if (!primaryImage || swatches.length === 0) return;

      let activeSwatch = swatches.find((swatch) => swatch.classList.contains('is-active')) || swatches[0];

      const previewSwatch = (swatch, commit = false) => {
        if (!swatch) return;

        if (swatch.dataset.imageSrc) {
          primaryImage.src = swatch.dataset.imageSrc;
          primaryImage.srcset = '';
          if (swatch.dataset.imageAlt) {
            primaryImage.alt = swatch.dataset.imageAlt;
          }
        }

        if (!commit) return;

        activeSwatch = swatch;
        swatches.forEach((item) => {
          const isActive = item === swatch;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-current', isActive ? 'true' : 'false');
        });

        if (swatch.dataset.variantUrl) {
          cardLinks.forEach((link) => {
            link.href = swatch.dataset.variantUrl;
          });
        }
      };

      swatches.forEach((swatch) => {
        swatch.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          previewSwatch(swatch, true);
        });
        swatch.addEventListener('pointerenter', () => previewSwatch(swatch));
        swatch.addEventListener('pointerleave', () => previewSwatch(activeSwatch));
        swatch.addEventListener('focus', () => previewSwatch(swatch));
        swatch.addEventListener('blur', () => previewSwatch(activeSwatch));
      });
    });
  };

  const initPredictiveSearch = () => {
    document.querySelectorAll('[data-predictive-search]').forEach((root) => {
      if (root.dataset.predictiveSearchReady === 'true') return;
      root.dataset.predictiveSearchReady = 'true';

      const input = root.querySelector('[data-predictive-search-input]');
      const panel = root.querySelector('[data-predictive-search-panel]');
      if (!input || !panel) return;

      let timer = null;
      let controller = null;
      let requestId = 0;

      const closePanel = () => {
        panel.hidden = true;
        panel.innerHTML = '';
      };

      const getProductImage = (product) => {
        const image = product.image || product.featured_image || product.featuredImage || null;
        if (typeof image === 'string') return image;
        return image?.url || image?.src || image?.transformed_src || '';
      };

      const getProductUrl = (product) => {
        if (product.url) return product.url;
        if (product.handle) return `/products/${product.handle}`;
        return '/search';
      };

      const renderEmpty = (message) => {
        panel.innerHTML = '';
        const empty = document.createElement('p');
        empty.className = 'predictive-search__empty';
        empty.textContent = message;
        panel.appendChild(empty);
        panel.hidden = false;
      };

      const renderProducts = (products) => {
        panel.innerHTML = '';
        if (!products.length) {
          renderEmpty('Nessun prodotto trovato');
          return;
        }

        products.forEach((product) => {
          const link = document.createElement('a');
          link.className = 'predictive-search__item';
          link.href = getProductUrl(product);

          const media = document.createElement('span');
          media.className = 'predictive-search__image';
          const imageSrc = getProductImage(product);
          if (imageSrc) {
            const image = document.createElement('img');
            image.src = imageSrc;
            image.alt = product.title || 'Prodotto';
            image.loading = 'lazy';
            media.appendChild(image);
          } else {
            media.classList.add('predictive-search__image--empty');
            media.textContent = 'Prodotto';
          }

          const body = document.createElement('span');
          const title = document.createElement('span');
          title.className = 'predictive-search__title';
          title.textContent = product.title || 'Prodotto';
          body.appendChild(title);

          const metaText = product.type || product.vendor || '';
          if (metaText) {
            const meta = document.createElement('span');
            meta.className = 'predictive-search__meta';
            meta.textContent = metaText;
            body.appendChild(meta);
          }

          link.appendChild(media);
          link.appendChild(body);
          panel.appendChild(link);
        });

        panel.hidden = false;
      };

      const performSearch = () => {
        const query = input.value.trim();
        if (query.length < 2) {
          closePanel();
          return;
        }

        requestId += 1;
        const currentRequest = requestId;
        if (controller) controller.abort();
        controller = new AbortController();

        const url = new URL('/search/suggest.json', window.location.origin);
        url.searchParams.set('q', query);
        url.searchParams.set('resources[type]', 'product');
        url.searchParams.set('resources[limit]', '6');
        url.searchParams.set('resources[options][unavailable_products]', 'hide');

        fetch(url.toString(), {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
          signal: controller.signal
        })
          .then((response) => (response.ok ? response.json() : null))
          .then((data) => {
            if (!data || currentRequest !== requestId) return;
            const products = data.resources?.results?.products || [];
            renderProducts(products);
          })
          .catch((error) => {
            if (error?.name !== 'AbortError') closePanel();
          });
      };

      const queueSearch = () => {
        window.clearTimeout(timer);
        timer = window.setTimeout(performSearch, 180);
      };

      input.addEventListener('input', queueSearch);
      input.addEventListener('focus', () => {
        if (input.value.trim().length >= 2 && panel.innerHTML) {
          panel.hidden = false;
        }
      });
      input.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          closePanel();
          input.blur();
        }
      });
      document.addEventListener('click', (event) => {
        if (!root.contains(event.target)) closePanel();
      });
    });
  };

  const initFeaturedProductsCacheRefresh = () => {
    const latestFeaturedBuild = '20260710-promotion-safe-v1';
    document.querySelectorAll('.featured-products-section').forEach((section) => {
      if (section.dataset.featuredProductsBuild === latestFeaturedBuild) return;
      const wrapper = section.closest('.shopify-section');
      const sectionId = wrapper?.id?.replace(/^shopify-section-/, '');
      if (!wrapper || !sectionId) return;

      const url = new URL(window.location.href);
      url.search = '';
      url.searchParams.set('section_id', sectionId);

      fetch(url.toString(), { credentials: 'same-origin' })
        .then((response) => (response.ok ? response.text() : ''))
        .then((html) => {
          if (!html) return;
          const container = document.createElement('div');
          container.innerHTML = html;
          const freshSection = container.querySelector('.featured-products-section');
          if (!freshSection || freshSection.dataset.featuredProductsBuild !== latestFeaturedBuild) return;
          wrapper.innerHTML = container.innerHTML;
          initProductCardSwatches();
        })
        .catch(() => {});
    });
  };

  const initCollectionCacheRefresh = () => {
    const latestCollectionBuild = '20260512-contextual-collection-v1';
    document.querySelectorAll('.collection-section').forEach((section) => {
      if (section.dataset.poliginoCollectionBuild === latestCollectionBuild) return;
      const wrapper = section.closest('.shopify-section');
      const sectionId = wrapper?.id?.replace(/^shopify-section-/, '');
      if (!wrapper || !sectionId) return;

      const url = new URL(window.location.href);
      url.search = '';
      url.searchParams.set('section_id', sectionId);

      fetch(url.toString(), { credentials: 'same-origin' })
        .then((response) => (response.ok ? response.text() : ''))
        .then((html) => {
          if (!html) return;
          const container = document.createElement('div');
          container.innerHTML = html;
          const freshSection = container.querySelector('.collection-section');
          if (!freshSection || freshSection.dataset.poliginoCollectionBuild !== latestCollectionBuild) return;
          wrapper.innerHTML = container.innerHTML;
          initProductCardSwatches();
          initSuccessivaAutoLoad();
          initCollectionFilters();
        })
        .catch(() => {});
    });
  };

  const initGlobalContextCacheRepair = () => {
    const path = window.location.pathname;
    const isNonTextileCollection = /^\/collections\/(?:all|cucina-tavola|persona-benessere|accessori-outdoor)(?:\/|$)/.test(path);

    if (isNonTextileCollection) {
      document.querySelectorAll('[data-material-guide-build], .material-layout').forEach((node) => {
        const section = node.closest('section') || node;
        const text = section.textContent || '';
        if (/Cotone, seta e spugna|Materiali tessili|Vedi cotone|Vedi microfibra/i.test(text)) {
          section.remove();
        }
      });
    }

    document.querySelectorAll('.footer-newsletter').forEach((newsletter) => {
      const text = newsletter.textContent || '';
      if (!/Guide tessili|consigli sui tessili/i.test(text)) return;
      const heading = newsletter.querySelector('h2');
      const paragraph = newsletter.querySelector('p:not(.eyebrow):not(.newsletter-form__message)');
      if (heading) heading.textContent = 'Ispirazioni per la tua casa e offerte riservate';
      if (paragraph) paragraph.textContent = 'Iscriviti per ricevere novità, consigli pratici e promozioni esclusive dal mondo Poligino.';
    });
  };

  const injectFaqCacheStyles = () => {
    if (document.getElementById('poligino-faq-cache-style')) return;
    const style = document.createElement('style');
    style.id = 'poligino-faq-cache-style';
    style.textContent = `
      .faq-layout {
        display: grid !important;
        grid-template-columns: minmax(280px, .42fr) minmax(0, .58fr) !important;
        grid-template-areas: none !important;
        column-gap: clamp(22px, 4vw, 54px) !important;
        row-gap: 0 !important;
        align-items: start !important;
      }
      .faq-layout > .faq-aside {
        grid-column: 1 !important;
        grid-row: 1 !important;
      }
      .faq-layout > .faq-panel {
        grid-column: 2 !important;
        grid-row: 1 / span 2 !important;
      }
      .faq-layout > .faq-intro {
        grid-column: 1 !important;
        grid-row: 1 !important;
        position: static !important;
        top: auto !important;
        display: flex !important;
        flex-direction: column !important;
        gap: 14px !important;
        min-width: 0 !important;
        padding: 32px 32px 0 !important;
        border: 1px solid rgba(30, 36, 34, .08) !important;
        border-bottom: 0 !important;
        border-radius: var(--radius) var(--radius) 0 0 !important;
        background: #f2f4f1 !important;
      }
      .faq-layout > .faq-contact-card {
        grid-column: 1 !important;
        grid-row: 2 !important;
        display: flex !important;
        flex-direction: column !important;
        gap: 10px !important;
        min-width: 0 !important;
        padding: 24px 32px 32px !important;
        border: 1px solid rgba(30, 36, 34, .08) !important;
        border-top: 1px solid rgba(30, 36, 34, .12) !important;
        border-radius: 0 0 var(--radius) var(--radius) !important;
        background: #f2f4f1 !important;
      }
      .faq-contact-card span {
        display: block !important;
        width: auto !important;
        margin: 0 !important;
        padding: 0 !important;
        border-radius: 0 !important;
        background: transparent !important;
        color: var(--color-muted) !important;
        font-size: .75rem !important;
        font-weight: 800 !important;
        line-height: 1.25 !important;
        letter-spacing: .08em !important;
        text-transform: uppercase !important;
      }
      .faq-contact-card h3 {
        margin: 0 !important;
        font-size: clamp(1.35rem, 2vw, 1.9rem) !important;
        line-height: 1.14 !important;
      }
      .faq-contact-card p {
        margin: 0 !important;
        max-width: 38ch !important;
        color: var(--color-muted) !important;
        line-height: 1.55 !important;
      }
      .faq-contact-card .button {
        width: fit-content !important;
        margin-top: 8px !important;
      }
      @media (max-width: 920px) {
        .faq-layout {
          grid-template-columns: 1fr !important;
          row-gap: 18px !important;
        }
        .faq-layout > .faq-aside,
        .faq-layout > .faq-panel,
        .faq-layout > .faq-intro,
        .faq-layout > .faq-contact-card {
          grid-column: 1 !important;
          grid-row: auto !important;
        }
        .faq-layout > .faq-intro {
          padding: 24px 24px 0 !important;
        }
        .faq-layout > .faq-contact-card {
          padding: 20px 24px 24px !important;
        }
      }
      @media (max-width: 640px) {
        .faq-layout > .faq-intro {
          padding: 20px 20px 0 !important;
        }
        .faq-layout > .faq-contact-card {
          padding: 18px 20px 20px !important;
        }
      }
    `;
    document.head.append(style);
  };

  const initFaqCacheRefresh = () => {
    const latestFaqBuild = '20260511-faq-flow-v1';
    injectFaqCacheStyles();
    document.querySelectorAll('.faq-layout').forEach((layout) => {
      const section = layout.closest('[data-faq-build]');
      if (section?.dataset.faqBuild === latestFaqBuild && section.querySelector('.faq-aside')) return;
      const wrapper = layout.closest('.shopify-section');
      const sectionId = wrapper?.id?.replace(/^shopify-section-/, '');
      if (!wrapper || !sectionId) return;

      const url = new URL(window.location.href);
      url.search = '';
      url.searchParams.set('section_id', sectionId);

      fetch(url.toString(), { credentials: 'same-origin' })
        .then((response) => (response.ok ? response.text() : ''))
        .then((html) => {
          if (!html) return;
          const container = document.createElement('div');
          container.innerHTML = html;
          const freshSection = container.querySelector('[data-faq-build]');
          if (!freshSection || freshSection.dataset.faqBuild !== latestFaqBuild || !freshSection.querySelector('.faq-aside')) return;
          wrapper.innerHTML = container.innerHTML;
        })
        .catch(() => {});
    });
  };

  const initSuccessivaAutoLoad = () => {
    const normalizeText = (value) => String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim();

    const isNextLink = (link) => {
      if (!link || !link.href) return false;
      if (link.dataset.paginationNext !== undefined) return true;
      const label = `${link.textContent || ''} ${link.getAttribute('aria-label') || ''}`;
      const rel = normalizeText(link.getAttribute('rel'));
      return normalizeText(label).includes('successiva') || rel.split(/\s+/).includes('next');
    };

    const gridSelectors = [
      '[data-product-grid]',
      '[data-paginated-items]',
      '.product-grid',
      '.blog-articles',
      '.article-grid',
      '.collection-list-grid'
    ].join(',');

    const findPaginationRoot = (link) => link.closest('[data-pagination], nav, .pagination') || link.parentElement;

    const findGridForPagination = (pagination) => {
      const scope = pagination.closest('.collection-section, .search-section, .blog-section, .section') || document.querySelector('main') || document;
      const grids = Array.from(scope.querySelectorAll(gridSelectors));
      const previousGrids = grids.filter((grid) => (
        grid.compareDocumentPosition(pagination) & Node.DOCUMENT_POSITION_FOLLOWING
      ));
      return previousGrids.pop() || grids[0] || null;
    };

    const getGridItems = (grid) => {
      const productCards = Array.from(grid.querySelectorAll('[data-product-card]'));
      if (productCards.length) return productCards;
      return Array.from(grid.children).filter((child) => !child.matches('.page-card, .product-grid__guide, .product-grid__proof'));
    };

    const getItemKey = (item) => {
      const link = item.querySelector('a[href*="/products/"], a[href]');
      if (link) {
        try {
          const url = new URL(link.href, window.location.origin);
          url.search = '';
          url.hash = '';
          return `${url.origin}${url.pathname}`;
        } catch (_error) {
          return link.getAttribute('href') || '';
        }
      }
      return item.id || item.textContent.trim().slice(0, 120);
    };

    const findFreshGrid = (container, currentGrid) => {
      if (currentGrid.dataset.productGrid !== undefined) {
        return container.querySelector('[data-product-grid]');
      }
      if (currentGrid.dataset.paginatedItems !== undefined) {
        return container.querySelector('[data-paginated-items]');
      }
      const classSelector = Array.from(currentGrid.classList)
        .map((className) => `.${window.CSS?.escape ? window.CSS.escape(className) : className.replace(/[^a-zA-Z0-9_-]/g, '\\$&')}`)
        .join('');
      return (classSelector && container.querySelector(classSelector)) || container.querySelector(gridSelectors);
    };

    const findNextLinkIn = (root) => Array.from(root.querySelectorAll('a[href]')).find(isNextLink);

    const isNearViewport = (element) => {
      const rect = element.getBoundingClientRect();
      return rect.top < window.innerHeight + 720 && rect.bottom > -240;
    };

    const paginationRoots = new Set();
    document.querySelectorAll('a[href]').forEach((link) => {
      if (!isNextLink(link)) return;
      const pagination = findPaginationRoot(link);
      if (pagination) paginationRoots.add(pagination);
    });

    paginationRoots.forEach((pagination) => {
      if (pagination.dataset.successivaAutoloadReady === 'true') return;
      const nextLink = Array.from(pagination.querySelectorAll('a[href]')).find(isNextLink);
      const grid = findGridForPagination(pagination);
      if (!nextLink || !grid) return;

      pagination.dataset.successivaAutoloadReady = 'true';
      pagination.dataset.autoLoadState = 'idle';
      pagination.classList.add('pagination-auto-load');

      const status = document.createElement('span');
      status.className = 'pagination-autoload-status';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      status.textContent = 'Scorri per caricare altri prodotti';
      pagination.append(status);

      const sentinel = document.createElement('span');
      sentinel.className = 'pagination-autoload-sentinel';
      sentinel.setAttribute('aria-hidden', 'true');
      pagination.append(sentinel);

      let nextUrl = nextLink.href;
      let isLoading = false;
      let observer = null;

      const setState = (state, text) => {
        pagination.dataset.autoLoadState = state;
        status.textContent = text;
      };

      const refreshDynamicBehaviors = () => {
        initProductCardSwatches();
        initCollectionFilters();
      };

      const complete = () => {
        setState('complete', 'Tutti i prodotti caricati');
        if (observer) observer.disconnect();
      };

      const loadNextPage = () => {
        if (isLoading || !nextUrl) return;
        isLoading = true;
        setState('loading', 'Caricamento prodotti...');

        fetch(nextUrl, { credentials: 'same-origin' })
          .then((response) => {
            if (!response.ok) throw new Error('Pagination request failed');
            return response.text();
          })
          .then((html) => {
            const container = document.createElement('div');
            container.innerHTML = html;
            const freshGrid = findFreshGrid(container, grid);
            if (!freshGrid) throw new Error('Pagination grid not found');

            const existingKeys = new Set(getGridItems(grid).map(getItemKey).filter(Boolean));
            const freshItems = getGridItems(freshGrid);
            let appendedCount = 0;

            freshItems.forEach((item) => {
              const key = getItemKey(item);
              if (key && existingKeys.has(key)) return;
              if (key) existingKeys.add(key);
              grid.append(item);
              appendedCount += 1;
            });

            const freshNextLink = findNextLinkIn(container);
            if (freshNextLink?.href && freshNextLink.href !== nextUrl) {
              nextUrl = freshNextLink.href;
              nextLink.href = nextUrl;
              setState('idle', appendedCount > 0 ? 'Altri prodotti caricati' : 'Scorri per caricare altri prodotti');
            } else {
              nextUrl = '';
              complete();
            }

            refreshDynamicBehaviors();

            if (nextUrl && isNearViewport(sentinel)) {
              window.setTimeout(loadNextPage, 250);
            }
          })
          .catch(() => {
            nextUrl = '';
            setState('error', 'Caricamento automatico non riuscito. Usa Successiva.');
          })
          .finally(() => {
            isLoading = false;
          });
      };

      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) loadNextPage();
        }, { rootMargin: '720px 0px' });
        observer.observe(sentinel);
      } else {
        window.addEventListener('scroll', () => {
          if (isNearViewport(sentinel)) loadNextPage();
        }, { passive: true });
      }

      if (isNearViewport(sentinel)) {
        window.setTimeout(loadNextPage, 300);
      }
    });
  };

  const initCollectionFilters = () => {
    const normalizeText = (value) => String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim();

    document.querySelectorAll('[data-collection-filters]').forEach((root) => {
      if (root.dataset.collectionFiltersReady === 'true') {
        root.dispatchEvent(new CustomEvent('collection:filters:refresh'));
        return;
      }
      const section = root.closest('.collection-section') || document;
      const grid = section.querySelector('[data-product-grid]');
      const buttons = Array.from(root.querySelectorAll('[data-filter-button]'));
      const resetButtons = [
        ...Array.from(root.querySelectorAll('[data-filter-reset]')),
        ...Array.from(section.querySelectorAll('.collection-empty-state [data-filter-reset]')),
      ];
      const emptyState = section.querySelector('[data-collection-empty]');
      const visibleCount = root.querySelector('[data-collection-visible-count]');
      const toggle = root.querySelector('[data-filter-toggle]');
      const state = {
        material: '',
        category: '',
        size: '',
      };

      const currentCards = () => (grid ? Array.from(grid.querySelectorAll('[data-product-card]')) : []);
      const currentExtras = () => (grid ? Array.from(grid.querySelectorAll('.product-grid__guide, .product-grid__proof')) : []);

      if (!grid || currentCards().length === 0) return;
      root.dataset.collectionFiltersReady = 'true';

      const groupDatasetKey = (group) => {
        if (group === 'material') return 'filterMaterial';
        if (group === 'category') return 'filterCategory';
        return 'filterSize';
      };

      const hasActiveFilters = () => Object.values(state).some(Boolean);

      const updateButtonState = () => {
        buttons.forEach((button) => {
          const group = button.dataset.filterGroupName;
          const value = button.dataset.filterValue || '';
          button.classList.toggle('is-active', state[group] === value);
        });
      };

      const updateProducts = () => {
        let count = 0;

        currentCards().forEach((card) => {
          const isVisible = Object.entries(state).every(([group, selected]) => {
            if (!selected) return true;
            const haystack = normalizeText(card.dataset[groupDatasetKey(group)]);
            return haystack.split(/\s+/).includes(selected) || haystack.includes(selected);
          });

          card.hidden = !isVisible;
          if (isVisible) count += 1;
        });

        currentExtras().forEach((item) => {
          item.hidden = hasActiveFilters();
        });

        if (visibleCount) visibleCount.textContent = String(count);
        if (emptyState) emptyState.hidden = count > 0;
        updateButtonState();
      };

      root.addEventListener('collection:filters:refresh', updateProducts);

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const group = button.dataset.filterGroupName;
          if (!Object.prototype.hasOwnProperty.call(state, group)) return;
          state[group] = button.dataset.filterValue || '';
          updateProducts();
        });
      });

      resetButtons.forEach((button) => {
        button.addEventListener('click', () => {
          Object.keys(state).forEach((key) => {
            state[key] = '';
          });
          updateProducts();
        });
      });

      if (toggle) {
        toggle.addEventListener('click', () => {
          const isOpen = root.classList.toggle('is-open');
          toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        });
      }

      updateProducts();
    });
  };

  const initMaterialTabs = () => {
    document.querySelectorAll('[data-material-tabs]').forEach((root) => {
      const tabs = Array.from(root.querySelectorAll('[data-material-tab]'));
      const panels = Array.from(root.querySelectorAll('[data-material-panel]'));

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const targetId = tab.getAttribute('aria-controls');
          tabs.forEach((item) => {
            const isActive = item === tab;
            item.classList.toggle('is-active', isActive);
            item.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });
          panels.forEach((panel) => {
            panel.classList.toggle('is-hidden', panel.id !== targetId);
          });
        });
      });
    });
  };

  const initAnnouncementTimers = () => {
    document.querySelectorAll('[data-announcement-timer]').forEach((timer) => {
      if (timer.dataset.timerReady === 'true') return;
      timer.dataset.timerReady = 'true';

      const valueEl = timer.querySelector('[data-announcement-timer-value]');
      const endAt = new Date(timer.dataset.timerEnd || '');
      const expiredText = timer.dataset.expiredText || 'Offerta terminata';
      if (!valueEl || Number.isNaN(endAt.getTime())) {
        timer.hidden = true;
        return;
      }

      const pad = (value) => String(value).padStart(2, '0');
      const render = () => {
        const remaining = endAt.getTime() - Date.now();
        if (remaining <= 0) {
          timer.classList.add('is-expired');
          timer.textContent = expiredText;
          return;
        }

        const totalSeconds = Math.floor(remaining / 1000);
        const days = Math.floor(totalSeconds / 86400);
        const hours = Math.floor((totalSeconds % 86400) / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;
        valueEl.textContent = days > 0
          ? `${days} giorni ${pad(hours)}:${pad(minutes)}:${pad(seconds)}`
          : `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
      };

      render();
      window.setInterval(render, 1000);
    });
  };

  const initDeliveryPromise = () => {
    document.querySelectorAll('[data-delivery-promise]').forEach((root) => {
      if (root.dataset.deliveryTimerReady === 'true') return;
      root.dataset.deliveryTimerReady = 'true';

      const cutoffEl = root.querySelector('[data-delivery-cutoff]');
      const countdownEl = root.querySelector('[data-delivery-countdown]');
      const windowEl = root.querySelector('[data-delivery-window]');
      if (!cutoffEl || !windowEl) return;

      const cutoffHour = Number.parseInt(root.dataset.cutoffHour || '14', 10);
      const minDays = Number.parseInt(root.dataset.minDays || '1', 10);
      const maxDays = Number.parseInt(root.dataset.maxDays || '3', 10);
      const timeZone = root.dataset.timeZone || 'Europe/Rome';
      const pad = (value) => String(value).padStart(2, '0');

      const zonedParts = (date) => {
        const formatter = new Intl.DateTimeFormat('en-GB', {
          timeZone,
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hourCycle: 'h23',
        });
        const parts = Object.fromEntries(formatter.formatToParts(date).map((part) => [part.type, part.value]));
        return {
          year: Number.parseInt(parts.year, 10),
          month: Number.parseInt(parts.month, 10),
          day: Number.parseInt(parts.day, 10),
          hour: Number.parseInt(parts.hour, 10),
          minute: Number.parseInt(parts.minute, 10),
          second: Number.parseInt(parts.second, 10),
        };
      };

      const zonedDateToUtc = (parts) => {
        const target = Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second || 0);
        let result = new Date(target);
        for (let attempt = 0; attempt < 2; attempt += 1) {
          const observed = zonedParts(result);
          const observedUtc = Date.UTC(
            observed.year,
            observed.month - 1,
            observed.day,
            observed.hour,
            observed.minute,
            observed.second
          );
          result = new Date(result.getTime() + target - observedUtc);
        }
        return result;
      };

      const calendarDate = (parts) => new Date(Date.UTC(parts.year, parts.month - 1, parts.day));

      const isBusinessDate = (date) => {
        const day = date.getUTCDay();
        return day !== 0 && day !== 6;
      };

      const nextBusinessDate = (date, includeCurrent = false) => {
        const result = new Date(date);
        if (!includeCurrent) result.setUTCDate(result.getUTCDate() + 1);
        while (!isBusinessDate(result)) {
          result.setUTCDate(result.getUTCDate() + 1);
        }
        return result;
      };

      const addBusinessDays = (date, days) => {
        const result = new Date(date);
        let remaining = Math.max(days, 0);
        while (remaining > 0) {
          result.setUTCDate(result.getUTCDate() + 1);
          if (isBusinessDate(result)) remaining -= 1;
        }
        return result;
      };

      const formatDate = (date) => {
        const parts = {
          year: date.getUTCFullYear(),
          month: date.getUTCMonth() + 1,
          day: date.getUTCDate(),
          hour: 12,
          minute: 0,
          second: 0,
        };
        return new Intl.DateTimeFormat('it-IT', {
          timeZone,
          weekday: 'short',
          day: 'numeric',
          month: 'short',
        }).format(zonedDateToUtc(parts));
      };

      const formatCutoffDuration = (milliseconds) => {
        const totalMinutes = Math.max(0, Math.floor(milliseconds / 60000));
        if (totalMinutes <= 0) return 'meno di 1 min';
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;
        return `${pad(hours)} ore ${pad(minutes)} min`;
      };

      cutoffEl.textContent = 'Spedizione';
      if (countdownEl) countdownEl.textContent = 'Costo al checkout';
      windowEl.textContent = 'Metodo, costi e tempi confermati al checkout';
      root.classList.remove('is-cutoff-active', 'is-cutoff-passed');
    });
  };

  initQuarantinedProductGuard();
  initProductCacheFallback();
  initAllProductsLinkCleanup();
  initCollectionsListCacheRepair();
  initGlobalContextCacheRepair();
  initQuantityInputs();
  initProductVariants();
  initQuarantinedDescriptionCleanup();
  initProductCardSwatches();
  initPredictiveSearch();
  initFeaturedProductsCacheRefresh();
  initCollectionCacheRefresh();
  initFaqCacheRefresh();
  initSuccessivaAutoLoad();
  initCollectionFilters();
  initMaterialTabs();
  initAnnouncementTimers();
  initDeliveryPromise();
})();
